import { render, staticRenderFns } from "./ValidationIcon.vue?vue&type=template&id=32f5c328&scoped=true"
import script from "./ValidationIcon.vue?vue&type=script&lang=js"
export * from "./ValidationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5c328",
  null
  
)

export default component.exports